export default "/images/vendor/flag-icon-css/flags/1x1/pr.svg?d478856bfb090d89128e3074f48f9ace";